module.exports = __webpack_public_path__ + "static/img/arrow-right.351fd49e.svg";